import './index.css'
import dayjs from '@disco/utils/dayjs'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import mixpanel from '@disco/api/mixpanel'
import { getGroupsLoading } from '@disco/state-management/selectors/groups'
import Button from 'components/ui/button'
import Spinner from 'components/ui/spinner'
import { Flex, Tabs } from 'components/ds'
import NotificationItem from './notification-item'
import ProductUpdates from './product-updates'
import { hasProductUpdatesApiKey } from './product-updates/use-product-updates'
import styles from './notification-pane.module.css'

const NOTIFICATIONS_TAB = 'notifications'
const PRODUCT_UPDATES_TAB = 'product-updates'
const DEFAULT_TAB = NOTIFICATIONS_TAB

class NotificationPane extends Component<any> {
  state = { activeTab: DEFAULT_TAB }

  // The pane stays mounted while hidden, so reset the tab on every open
  componentDidUpdate(prevProps) {
    if (this.props.isVisible && !prevProps.isVisible) {
      this.setState({ activeTab: DEFAULT_TAB })
    }
  }

  _handleTabChange = activeTab => {
    this.setState({ activeTab })
    if (activeTab === PRODUCT_UPDATES_TAB) {
      mixpanel.sendPureEvent('Open product updates via notifications', {
        Context: 'Notifications',
      })
    }
  }

  render() {
    // TODO: DEPRECATED (props.timeline is not used)
    const { hasScrollBar, timeline, groupsLoading } = this.props
    const hasScrollBarClass = hasScrollBar
      ? 'NotificationPane_HasScrollBar'
      : ''
    const showProductUpdates = hasProductUpdatesApiKey()
    return (
      <div className="NotificationPane">
        <Tabs.Root
          value={this.state.activeTab}
          onValueChange={this._handleTabChange}
          className={styles.tabsRoot}
        >
          <Tabs.List className={styles.tabsList}>
            <Tabs.Trigger value={NOTIFICATIONS_TAB}>Notifications</Tabs.Trigger>
            {showProductUpdates && (
              <Tabs.Trigger value={PRODUCT_UPDATES_TAB}>
                Product updates
              </Tabs.Trigger>
            )}
          </Tabs.List>
          <Tabs.Content value={NOTIFICATIONS_TAB}>
            <Flex justify="end" py="2">
              <Button
                appearance="inline-link"
                caption="Clear all"
                compact={true}
                disabled={
                  this.props.notifications.length === 0 || groupsLoading
                }
                onClick={this.props.onClearAll}
              />
            </Flex>
            <div className={`NofiticationPane_ScrollCont ${hasScrollBarClass}`}>
              {groupsLoading ? (
                <Spinner />
              ) : (
                <div className="NofiticationPane_Body">
                  {timeline && this._renderTimelineBackground()}
                  {this._renderNotifications()}
                </div>
              )}
            </div>
          </Tabs.Content>
          {showProductUpdates && (
            <Tabs.Content value={PRODUCT_UPDATES_TAB}>
              <ProductUpdates />
            </Tabs.Content>
          )}
        </Tabs.Root>
      </div>
    )
  }

  _renderNotifications() {
    const { notifications } = this.props

    if (notifications.length > 0) {
      return notifications.map(this._renderNotification)
    } else {
      return (
        <div className="NotificationPane_Empty">
          You don’t have any notifications
        </div>
      )
    }
  }

  _renderNotification = (item, index, notifications) => {
    const { timeline, onOpenNotification, onDismiss } = this.props
    return (
      <NotificationItem
        key={item.api_url || item.message_id}
        item={item}
        hasDismissButton={this.props.hasDismissButton}
        timelineItem={
          timeline
            ? this._renderTimelineItem({
                timestamp: item.timestamp,
                isFirst: index === 0,
                isLast: index === notifications.length - 1,
              })
            : null
        }
        onOpenNotification={onOpenNotification}
        onExpandNotification={this.props.onExpandNotification}
        onDismiss={onDismiss}
        onOpenPlaylist={this.props.onOpenPlaylist}
        onOpenBriefSubmission={this.props.onOpenBriefSubmission}
        onOpenDiscussion={this.props.onOpenDiscussion}
        onAcceptChannelInvite={this.props.onAcceptChannelInvite}
        onOpenLibraryClients={this.props.onOpenLibraryClients}
        onOpenTrackRoute={this.props.onOpenTrackRoute}
        onClickLink={this.props.onClickLink}
      />
    )
  }

  _renderTimelineBackground() {
    return (
      <div className="NotificationPane_TimelineBackground">
        <div className="NotificationPane_TimelineLine" />
      </div>
    )
  }

  _renderTimelineItem({ timestamp, isFirst, isLast }) {
    const isFirstClass = isFirst ? 'NotificationPane_IsFirst' : ''
    const isLastClass = isLast ? 'NotificationPane_IsLast' : ''
    return (
      <div
        className={`NotificationPane_TimelineCont ${isFirstClass} ${isLastClass}`}
      >
        <div className="NotificationPane_TimelineBox">
          {dayjs(timestamp).format('MMM D')}
        </div>
      </div>
    )
  }
}

export default connect(state => {
  return {
    groupsLoading: getGroupsLoading(state),
  }
})(NotificationPane)
